import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
import { Layout, Breadcrumb, Row, Typography, Spin } from "antd";

/**
 * Components
 */
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import { LayoutTopSide } from "components/NavBar/styles";
import "./styles.scss";

/**
 * Actions
 */
import { ProCard } from "@ant-design/pro-components";
import { reportAPI } from "../../services/actions/reports-v2";

/**
 * Misc
 */
const { Footer } = Layout;
const { Paragraph } = Typography;


const Dashboard = () => {

  const isDarkMode = useSelector((state) => state.theme.isDarkMode);

  const fetchReport = async () => {
    try {
      const { status, data } = await reportAPI.getEmbedDefaultReport();
      if (status === 200 || status === 201) {
        setReport(data);
      } else {
        throw new Error("Failed to fetch report");
      }
    } catch (error) {
      setError("Ocorreu um erro ao buscar o relatório.");
    } finally {
      setLoading(false);
    }
  };

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchReport();
  }, [])
  return (
    <LayoutTopSide>
      <TopBar />
      <Layout style={{ overflow: "hidden" }}>
        <DrawerSider />
        <Layout className="dashboard-layout" style={{ height: "100%" }}>
          <PageHeader
            style={{ margin: "16px 0 5px 0", flex: "0 0 auto" }}
            title="Dashboard"
            subTitle="Acompanhe o resumo dos seus relatórios e indicadores."
            breadcrumb={
              <Breadcrumb>
                <Breadcrumb.Item>dashboard</Breadcrumb.Item>
                <Breadcrumb.Item>resumo</Breadcrumb.Item>
              </Breadcrumb>
            }
          />

          <Row style={{ flex: 1, minHeight: 0 }}>
            <ProCard className="report-card">
              {loading ? (
                <Spin tip="Carregando relatório..." />
              ) : error ? (
                <Paragraph>{error}</Paragraph>
              ) : (
                report && !loading ? (
                  <iframe
                    key={isDarkMode ? "dark" : "light"}
                    src={`${process.env.REACT_APP_URL}/metabase/embed/dashboard/${report}#bordered=true&titled=true${isDarkMode ? "&theme=night" : ""}`}
                    title="Relatório"
                    style={{ width: "100%", flex: 1, minHeight: 0, border: "none" }}
                  />
                ) : (<Paragraph style={{ textAlign: "center" }}>Não há relatório padrão definido.</Paragraph>)
              )}
            </ProCard>
          </Row>
          <Footer style={{ textAlign: "center", flex: "0 0 auto", padding: "12px 24px", background: "transparent" }}>
            CLM ©{new Date().getFullYear()} Versão {process.env.REACT_APP_VERSION || "1.0"}
          </Footer>
        </Layout>
      </Layout>
    </LayoutTopSide>
  );
}

export default Dashboard;
